import React from 'react';

var Accessibility = function Accessibility(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Accessibility"), /*#__PURE__*/React.createElement("path", {
    d: "M13.146 9h2.704a1 1 0 0 1 0 2h-2.418l.285 2h3.133a1 1 0 0 1 .707.293l2 2a1 1 0 0 1-1.414 1.414L16.436 15H12.85a1 1 0 0 1-.99-.859l-1-7a1 1 0 1 1 1.98-.282L13.146 9zM11.35 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-2.715 6.58a1 1 0 1 1 .785 1.84 3.426 3.426 0 0 0-2.07 3.156C7.35 18.47 8.867 20 10.733 20c1.43 0 2.692-.906 3.177-2.244a1 1 0 0 1 1.88.683A5.386 5.386 0 0 1 10.733 22c-2.975 0-5.383-2.43-5.383-5.424a5.425 5.425 0 0 1 3.285-4.996z",
    fill: "currentColor"
  }));
};

Accessibility.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { Accessibility as icon };
export default iconHandler(Accessibility);